// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneCategoryFragmentDoc } from './StoneCategory.fragment.generated';
import { StoneClarityFragmentDoc } from './stoneClarity.fragment.generated';
import { StoneColorFragmentDoc } from './StoneColor.fragment.generated';
import { StoneCrystalFragmentDoc } from '../../nonsku/fragments/stoneCrystal.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../../components/useImageProps.generated';
import { StoneImageFragmentDoc } from './image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../../../domain/stone/certificate.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
export const StoneFragmentDoc = gql`
    fragment stone on GemsApi_Stone {
  __typename
  identifier
  blackInclusion
  categoryWithInfo {
    code
    info {
      ...stoneCategory
    }
  }
  clarityWithInfo {
    code
    info {
      ...stoneClarity
    }
  }
  colorWithInfo {
    code
    info {
      ...stoneColor
    }
  }
  crystalWithInfo {
    code
    info {
      ...stoneCrystal
    }
  }
  colourShade
  crystal
  culet
  cutWithInfo {
    __typename
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  eyeClean
  fluorescenceWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  fluorescenceColour
  girdleMin
  girdleMax
  gradeWithInfo {
    code
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  growthMethod
  polishWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  shapeWithInfo {
    code
    info {
      systemCode
      samplePhoto {
        id
        size: size(name: MEDIUM) {
          ...monolithImageSize
        }
        size_x2: size(name: MEDIUM_X2) {
          ...monolithImageSize
        }
      }
      icon {
        id
        url
      }
      translation(locale: $locale) {
        name
      }
    }
  }
  symmetryWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  shippingFromCountry
  originCountry
  length
  width
  depth
  weight
  ratio
  pavilionDepth
  pavilionAngle
  tablePercent
  depthPercent
  crownAngle
  crownHeight
  image {
    ...StoneImage
  }
  images {
    ...StoneImage
  }
  v360Url
  isMilky
  isTreated
  isCertificateVerified
  isCanadaMark
  isB2B
  isValidB2C
  isHideCertificateNumber
  isHideMeasurements
  deliveryDays
  ...gemsApiCertificate
  dtlReport {
    __typename
    url
    code
  }
  scsReport
  salePrice(currency: $currency, region: $region) {
    ...money
  }
  price
}
    ${StoneCategoryFragmentDoc}
${StoneClarityFragmentDoc}
${StoneColorFragmentDoc}
${StoneCrystalFragmentDoc}
${MonolithImageSizeFragmentDoc}
${StoneImageFragmentDoc}
${GemsApiCertificateFragmentDoc}
${MoneyFragmentDoc}`;